const product = {
    state: {
        product: null,
        selectedVariant: {}
    },
    mutations: {
        setProduct(state, payload) {
            state.product = payload;
        },
        setSelectedVariant(state, payload) {
            state.selectedVariant = payload;
        },
    },
    actions: {
        async fetchProduct({ commit }, productUid) {
            const { data } = await axios.get(`/api/product/${productUid}`);
            commit('setProduct', data.data);
        }
    },
    getters: {
        files: state => {
            return state.selectedVariant?.files?.length ? state.selectedVariant.files : (state.product ? state.product.files : []);
        }
    }
};

export default product;
